import './bootstrap';

// import Alpine from 'alpinejs';
// import intersect from '@alpinejs/intersect'
//
// window.Alpine = Alpine;
// Alpine.plugin(intersect);
// Alpine.start();

function update() {

    const elems = document.getElementsByClassName("nav-parent");
    const centrePoint = window.innerWidth/2;

    [...elems].forEach(elem => {
        let rect = elem.getBoundingClientRect();
        let xpos = rect['x'] + (rect['width'] / 2);
        let dropdown = elem.querySelector('.nav-dropdown');
        if(xpos > centrePoint) {
            dropdown.classList.remove('lg:-left-4');
            dropdown.classList.add('lg:-right-4');
        } else {
            dropdown.classList.remove('lg:-right-4');
            dropdown.classList.add('lg:-left-4');
        }
    });

}

const categoriesOpenCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
        if (
            mutation.type !== "attributes" ||
            mutation.attributeName !== "open"
        ) {
            return
        }
        if(mutation.target.getAttribute("open") === null) {
            let childDetailElements = mutation.target.querySelectorAll('details[open]');
            [...childDetailElements].forEach(childDetailElement => {
                childDetailElement.removeAttribute('open');
            });
        }
    }
}

const observer = new MutationObserver(categoriesOpenCallback);

const accordions = document.getElementsByTagName("details");

window.addEventListener("load", (event) => {

    update();

    [...accordions].forEach(accordion => {
        observer.observe(accordion, { attributes: true })
    });

});

window.addEventListener("resize", (event) => {
    update();
});
